import type { AriaAttributes, HTMLAttributes } from 'react';

import type { Nullable } from '../../types';

type BaseProps = {
  orientation?: AriaAttributes['aria-orientation'];
};

export type Props = BaseProps &
  (
    | {
        label: Nullable<string>;
        labelId?: never;
      }
    | {
        label?: never;
        labelId: string;
      }
  );

export type Result = HTMLAttributes<HTMLElement>;

export const useTabList = ({
  label = undefined,
  labelId = undefined,
  orientation = `vertical`,
}: Props): Result => ({
  role: `tablist`,
  'aria-label': label || undefined,
  'aria-labelledby': labelId,
  'aria-orientation': orientation,
});
